export class Exchanges {
  static Bitmex = 'bitmex';
  static Kraken = 'kraken';
}
